Advertisement branding details and images.

This can be associated with one or more `PositionProfile`s when they are created.

Branding images are visible to candidates searching for positions or viewing a job ad with this associated advertisement branding.
